import React, {useEffect, useMemo, useRef, useState} from 'react'
import styles from './index.module.scss'
import GetIcon from "../GetIcon";
import {Tooltip} from "antd";
import generateIconUrl from "../../utils/generateIconUrl";

export default function CardMembersList({cardMembers, excludeDimensions = [], excludeMembers = []}) {
    const [nextActive, setNextActive] = useState(true);
    const [prevActive, setPrevActive] = useState(false);
    const [indexSlide, setIndexSlide] = useState(0);
    const containerRef = useRef(null)

    const next = () => {
        setIndexSlide(indexSlide + 1)
    }

    const prev = () => {
        setIndexSlide(indexSlide - 1)
    }

    useEffect(() => {
        if (containerRef.current) {
            const scrollViewWidth = containerRef.current.offsetWidth * indexSlide;

            containerRef.current.scrollTo({
                left: scrollViewWidth,
            });

            setPrevActive(scrollViewWidth !== 0)
            setNextActive((scrollViewWidth + containerRef.current.offsetWidth) < containerRef.current.scrollWidth)
        }
    }, [indexSlide])

    return (
        <div className={styles.cardMembersNavigate}>
            {prevActive && (
                <div onClick={prev} className={`${styles.cardMembersNavigate__arrow} ${styles.left}`}>
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 1L9.5 7L3.5 13" stroke="#323238" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            )}
            <div className={styles.cardMembersNavigate__overlay} ref={containerRef}>
                {cardMembers.map(({name, icon, id, dimension}) => {
                    if(excludeDimensions.includes(dimension?.id) || excludeMembers.includes(id)){
                        return null
                    }

                    return (
                        <Tooltip placement="top" title={dimension?.name}>
                            <div key={id} className={styles.cardMembersNavigate__item}>
                                {icon && (
                                    <div className={styles.cardMembersNavigate__item_icon}>
                                        <GetIcon backendUrl={generateIconUrl(icon, "icon")}/>
                                    </div>
                                )}
                                {name}
                            </div>
                        </Tooltip>
                    )
                })}
            </div>
            {nextActive && (
                <div onClick={next} className={`${styles.cardMembersNavigate__arrow} ${styles.right}`}>
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 1L9.5 7L3.5 13" stroke="#323238" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            )}
        </div>
    )
}

